import { render, staticRenderFns } from "./InstrucoesReserva.vue?vue&type=template&id=40284acc"
import script from "./InstrucoesReserva.vue?vue&type=script&lang=js"
export * from "./InstrucoesReserva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports